import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StoreResponseDto } from 'src/generated_client';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }


  currentUserStore(): StoreResponseDto {
    let store: StoreResponseDto;
    store = {
      token: this.localStorageService.getItem('storeToken'),
      cdStore: this.localStorageService.getItem('storeId'),
      dsName: this.localStorageService.getItem('storeName'),
      dsEmail: this.localStorageService.getItem('storeMail')
    }
    return store
  }

  loginStore(x: StoreResponseDto) {
    this.localStorageService.setItem('storeToken', x.token);
    this.localStorageService.setItem('storeId', x.cdStore);
    this.localStorageService.setItem('storeName', x.dsName);
    this.localStorageService.setItem('storeMail', x.dsEmail);
  }

  logoutStore() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  getStoreToken() {
    let token: string;
    token = this.localStorageService.getItem('storeToken');
    return token
  }
}
